import React from 'react';
import PropTypes from 'prop-types';
import toNumber from 'lodash/toNumber';
import map from 'lodash/map';

import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import useStyles from './styles';

const values = [1, 2, 3, 4, 5];

function Input({onChange, value, ...rest}) {

  const classes = useStyles();

  const _onChange = event => {
    onChange({target: {
      id: 'maxEnrolled',
      name: 'maxEnrolled',
      value: toNumber(event?.target?.value)
    }})
  }

  return (
    <TextField
      id='maxEnrolled'
      name='maxEnrolled'
      label='Número Máximo'
      placeholder='Número Máximo'
      autoComplete='off'
      className={classes.formControl}
      onChange={_onChange}
      InputLabelProps={{
        shrink: true
      }}
      fullWidth
      required
      select
      value={toNumber(value)}
      {...rest}
    >
      {map(values, el =>
        <MenuItem key={el} value={el}>
          {el}
        </MenuItem>
      )}
    </TextField>
  );
}

Input.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool
};

export default Input;
